import { Injectable } from "@angular/core";

import { WebConstants } from "../util/web.constants";
import { Observable } from "rxjs";
import { BaseResponse } from "../model/base.response";
import { AjaxHelper } from "../helper/ajax.helper";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class EventManagementService {
  public baseUrl: string = environment.BaseServiceUrl;

  constructor(public ajaxHelper: AjaxHelper) {}

  getAllUpcoming(): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(
      this.baseUrl + WebConstants.API_URL.EVENT_MANAGEMENT.FIND_ALL_UPCOMING
    );
  }

  assignEventPeo(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.EVENT_MANAGEMENT.ASSIGN_EVENT_PEO, payload);
  }

  getPeoByEvent(eventId: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.EVENT_MANAGEMENT.FIND_PEO_BY_EVENT_ID + "/" + eventId);
  }

  removePeoFromEvent(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.EVENT_MANAGEMENT.REMOVE_PEO_FROM_EVENT, payload);
  }
}
